<template lang="pug">
  .b-ui-key-val
    ._row(v-for="item in items")
      ._key {{ item.key }}:
      ._val.val {{ item.val }}
</template>

<script>
export default {
  name: 'UiKeyVal',
  props: {
    items: Array,
  },
};
</script>

<style scoped lang="scss">
.ui-key-val {
  display: flex;
  flex-direction: column;
  gap: 10px;

  &__row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__key {
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.01em;
    color: #92A0B0;
  }

  &__val {
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.01em;
    color: #1E3147;
  }
}
</style>
